const status = (state = [], action) => {
  
  switch (action.type) {
    case 'ADD_STATUS':
    console.log("ADD_STATUS", action)
    return {
        type: "ADD_STATUS",
        status: action.status,
        reason: action.reason,
        idreason: action.status === 'Pausado' ? action.idreason: -1, 
        datestatus: action.datestatus,
        afterStatus: action.status === 'Pausado' || action.status === 'Livre' || action.status === 'Bloqueado' ? action.status:state.afterStatus,
        afterReason: action.status === 'Pausado' || action.status === 'Livre' || action.status === 'Bloqueado' ? action.reason:state.afterReason,
        afterIdReason: action.status === 'Pausado' || action.status === 'Livre' || action.status === 'Bloqueado' ? action.idreason:state.afterIdReason,
        afterIsReasonLogout: action.status === 'Pausado' || action.status === 'Livre' || action.status === 'Bloqueado' ? action.islogout:state.afterIsReasonLogout,
        allowCall: true,
        allowCapture: true
      }
    case 'CHANGE_BLOCK':
      return { ...state,
          type: "CHANGE_BLOCK",
          afterStatus: 'Livre',
          afterReason: 'Livre',
          afterIdReason: -1,
          afterIsReasonLogout: false
        }
    case 'CHANGE_PERMISSION':
      return { ...state,
          type: "CHANGE_PERMISSION",
          allowCall: action.allowCall,
          allowCapture: action.allowCapture,
        }
    default:
      return state
  }
}

export default status